import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './inc-api.utils';

export const incApi = createApi({
  reducerPath: 'inc-admin-api',
  tagTypes: [
    'Store',
    'Stores',
    'Merchant',
    'Merchants',
    'ClientConfig',
    'PaymentAccount',
    'PaymentAccounts',
    'PaymentAccountLink',
    'Transactions',
    'Transaction',
    'GiftCardTransaction',
    'Admins',
    'Admin',
    'Role',
    'Roles',
    'Timezones',
    'Countries',
    'Regions',
    'Reports',
    'GuestJourneyReport',
    'Client',
    'StoreOrderingSetting',
    'CustomerTag',
    'CustomerTags',
    'Product',
    'Products',
    'Segment',
    'Segments',
    'Campaign',
    'Campaigns',
    'Customer',
    'LoyaltyHistory',
    'PromoCode',
    'PromoCodes',
    'Program',
    'Programs',
    'DIItem',
    'DIItems',
    'DIGroup',
    'DIGroups',
    'Menu',
    'LoyaltySettings',
    'Offer',
    'Offers',
    'OfferDistributionSettings',
    'DraftOffer',
    'DraftOffers',
    'Message',
    'Messages',
    'DraftMessage',
    'DraftMessages',
    'Survey',
    'Surveys',
    'ProductItem',
    'Item',
    'Items',
    'Chargeback',
    'ChargebackFileLink',
    'Chargebacks',
    'PresignedUrlsClient',
    'ImageUploads',
    'SalesOrder',
    'Order',
    'Orders',
    'AccountLoyaltySummary',
    'LocationsConfigured',
    'Customers',
    'CustomerOffers',
    'AmountByLocationList',
    'PastImports',
    'GiftCards',
    'GiftCard',
    'ClientEmailConfig',
    'Integrations',
    'EmailTemplates',
    'EmailTemplate',
    'EmailTemplateRelatedItems',
    'EmailTemplateMergeTags',
    'GiftCardTransaction',
    'GiftCardTransactions',
    'Group',
    'Groups',
    'Menu',
    'Menus',
    'SMSTotal',
    'MarketingSMSProgram',
    'OrderConfirmationList',
    'AccountVerificationList',
    'GuestCheckoutVerificationList',
    'PasswordlessAuthenticationList',
    'GiftCardImport',
    'MLRules',
    'MLItemDetails',
    'MLModelStatus',
    'MLConfiguration',
    'MLStores',
    'ClientDomain',
    'ClientDomains',
    'ACHLocation',
    'ACHLocations',
    'EmailPulseOverview',
    'EmailPulseOverviews',
    'CustomerTransactions',
    'AppHomeConfig',
    'AppHomeConfigAudit',
    'WebAppConfig',
  ],
  baseQuery: baseQueryWithReauth,
  // We need to declare these here to avoid circular dependency issues with
  // these specific endpoints. When we declare endpoints in separate files,
  // they will be injected here and override these.
  //
  // Any endpoints that need to be used in redux slice extraReducers will
  // need to be declared here.
  endpoints: /* istanbul ignore next */ build => ({
    token: build.mutation({ query: () => 'will be overridden' }),
    logout: build.query({ query: () => 'will be overridden' }),
    getAdmin: build.query({ query: () => 'will be overridden' }),
    listMerchants: build.query({ query: () => 'will be overridden' }),
    listStores: build.query({ query: () => 'will be overridden' }),
    getClientConfig: build.query({ query: () => 'will be overridden' }),
    listPrograms: build.query({ query: () => 'will be overridden' }),
    getCampaign: build.query({ query: () => 'will be overridden' }),
    createCampaigns: build.mutation({ query: () => 'will be overridden' }),
    updateCampaign: build.mutation({ query: () => 'will be overridden' }),
    deleteCampaign: build.mutation({ query: () => 'will be overridden' }),
    listCampaigns: build.query({ query: () => 'will be overridden' }),
    chmlnSignature: build.query({ query: () => 'will be overridden' }),
    getIntegrations: build.query({ query: () => 'will be overridden' }),
    updateClientConfig: build.mutation({ query: () => 'will be overridden' }),
    getClientDomainsByClientId: build.query({
      query: () => 'will be overridden',
    }),
  }),
});
